import React from 'react';
import PropTypes from 'prop-types';
import { msalInstance, isUsingEntraAuth } from '../../msal';
import AccessDenied from '../AccessDenied';

const ADMIN_ROLE = 'Admin';

const AdminRouteGuard = ({ children }) => {
  if (!isUsingEntraAuth) {
    return children;
  }

  const accounts = msalInstance.getAllAccounts();
  const roles = accounts?.[0]?.idTokenClaims?.roles ?? [];

  if (!roles.includes(ADMIN_ROLE)) {
    return <AccessDenied overrideText="Admin access required" />;
  }

  return children;
};

AdminRouteGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminRouteGuard;
